import { FormFieldModel } from '../../PageBuilder/models/form-field.model';
import { AbstractFormFieldComponent } from '../../PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';

export class DateRangeFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    allowAllOption: boolean;
    appearCondition?: (x: any) => boolean;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        allowAllOption: boolean = true,
        appearCondition?: (x: any) => boolean
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.allowAllOption = allowAllOption;
        this.appearCondition = appearCondition;
    }
}
